import useShowCarouselButtons from "hooks/useShowCarouselButtons";
import { ButtonNext, ButtonPrev } from "./styles"

const CarouselButtons = ({
  classPrev,
  classNext,
  nextSlide,
  prevSlide
}) => {
  
  const { showNavigationBtns } = useShowCarouselButtons();

  if (!showNavigationBtns) return null

  return (
    <>
      <ButtonPrev
        className={classPrev}
        onClick={prevSlide}
      />
      <ButtonNext
        className={classNext}
        onClick={nextSlide}
      />
    </>
  )
}

export default CarouselButtons